import axios from './axios'
import store from './store/store'

/* eslint-disable no-console */
const userInfo = localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo')
function updateCurrentPosition(position) {
  axios
    .put('auth/profile', {
      username: userInfo.username,
      location: {
        lat: position.coords.latitude,
        lon: position.coords.longitude
      }
    })
    .then(response => {
      store.commit('UPDATE_USER_INFO', response.data)
      console.debug('[GPS] Location information updated.')
    })
    .catch(err => console.log(err))
}

function onErrorGettingPosition(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      console.debug('[GPS] User denied the request for Geolocation.')
      break
    case error.POSITION_UNAVAILABLE:
      console.debug('[GPS] Location information is unavailable.')
      break
    case error.TIMEOUT:
      console.debug('[GPS] The request to get user location timed out.')
      break
    case error.UNKNOWN_ERROR:
      console.debug('[GPS] An unknown error occurred.')
      break
  }
}

export const getCurrentPosition = () => {
  if (userInfo) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(updateCurrentPosition, onErrorGettingPosition)
    } else {
      console.debug('Geolocation is not supported by this browser.')
    }
  }
}
getCurrentPosition()
